import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import { sidebarAtom, userAtom } from "../store";
import { useAtom } from "jotai";
import { HiOutlineLogout, HiUser } from "react-icons/hi";
import { Button } from "@material-tailwind/react";
import { useEffect } from "react";
import UserAPI from "../api/user";

const Layout = () => {
    const [sidebar] = useAtom(sidebarAtom);
    const [userAuth] = useAtom(userAtom);
    const navigate = useNavigate();

    useEffect(() => {
        if (!userAuth?.token || !userAuth?.role || userAuth?.role !== "admin") {
            navigate("/login");
        }
    }, [navigate, userAuth]);

    const logout = () => {
        UserAPI.logout();
        navigate("/login");
    }

    return (
        <div className="flex h-screen bg-gray-100">
            <Sidebar />

            <div className="flex flex-col flex-1">
                <header className="flex items-center justify-between px-6 py-3 bg-white border-b">
                    <div>
                        <div className="flex items-center gap-1 text-14">
                            <div className="opacity-50">Dashboard</div>
                            <div className="capitalize">/ {sidebar}</div>
                        </div>
                        <div className="font-medium capitalize text-16">{sidebar} Page</div>
                    </div>
                    <div className="flex items-center gap-2">
                        <div className="flex items-center pr-2" >
                            <HiUser className="w-8 h-8" />
                            <div className="ml-2">
                                <div className="-mb-1 opacity-50 text-12">Role</div>
                                <div className="font-medium capitalize text-16">{userAuth?.role}</div>
                            </div>
                        </div>
                        <Button className="flex items-center px-4 py-2" onClick={logout}>
                            <HiOutlineLogout className="w-5 h-5" />
                            <div className="ml-2 font-medium normal-case text-14">Logout</div>
                        </Button>
                    </div>
                </header>

                <main className="flex-1 p-6 overflow-auto">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}

export default Layout;
